import { render, staticRenderFns } from "./CadastrosChart.vue?vue&type=template&id=1bb11a70"
import script from "./CadastrosChart.vue?vue&type=script&lang=js"
export * from "./CadastrosChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports